<div [id]="uniqueId" class="phone-input-root" role="group" [attr.aria-label]="getRootAriaLabel()">
    <div class="input-row">
        <button type="button" class="phone-input-prefix" [class.prefix-open]="dropdownOpen" aria-haspopup="listbox"
            [attr.aria-expanded]="dropdownOpen" (click)="toggleDropdown()">
            <img class="flag-icon" [src]="selectedPrefix?.url ?? '/assets/images/flags/spain.webp'"
                alt="{{ selectedPrefix?.code ?? 'flag' }}" loading="lazy" />
            <span class="prefix-text">{{ selectedPrefix?.prefix }}</span>
            <img class="arrow-icon" src="/assets/icons/arrow-down.svg" alt="" aria-hidden="true" />
        </button>

        <div class="input-wrapper">
            <input class="number-input" type="tel" [formControl]="localNumber"
                [attr.maxlength]="getMaxLocalLengthForSelectedPrefix()" [attr.placeholder]="getLocalNumberPlaceholder()"
                (focus)="dropdownOpen = false" (blur)="markTouched()" (wheel)="$event.preventDefault()"
                [attr.aria-label]="getInputAriaLabel()"
                [attr.aria-describedby]="uniqueId + '-error'" />

        </div>
    </div>

    <div class="error-message" [class.helper-message]="!hasErrorMessage()" *ngIf="getHelperOrErrorMessage()"
        [id]="uniqueId + '-error'">
        {{ getHelperOrErrorMessage() }}
    </div>

    <!-- dropdown: mantenemos tu estructura (favoritos + scroll) -->
    <div class="dropdown" *ngIf="dropdownOpen" role="listbox"
        [attr.aria-activedescendant]="selectedPrefix ? (uniqueId + '-option-' + selectedPrefix.code) : null">
        <ng-container *ngIf="favoritePrefixes.length">
            <div class="dropdown-item" *ngFor="let p of favoritePrefixes; trackBy: trackByCode"
                [id]="uniqueId + '-option-' + p.code" [class.selected]="selectedPrefix?.code === p.code"
                (click)="onPrefixChange(p)" (keydown)="onPrefixKeydown($event, p)" tabindex="0" role="option"
                [attr.aria-selected]="selectedPrefix?.code === p.code">
                <div class="dropdown-item-content">
                    <img class="flag-icon" [src]="p.url" [alt]="p.code" loading="lazy" />
                    <div class="dropdown-meta">
                        <div class="country-name">{{ p.nameTranslated }}</div>
                        <div class="country-prefix">{{ p.prefix }}</div>
                    </div>
                </div>
                <img *ngIf="selectedPrefix?.code === p.code" class="check-icon" src="/assets/icons/solid_check.webp"
                    alt="" />
            </div>

            <div class="dropdown-item-spliter">{{ 'phone_number_input.ALL_COUNTRIES' | translate }}</div>
        </ng-container>

        <div class="dropdown-scroll-container" role="presentation">
            <div class="dropdown-item" *ngFor="let p of prefixes; let last = last; trackBy: trackByCode"
                [id]="uniqueId + '-option-' + p.code" [class.selected]="selectedPrefix?.code === p.code"
                (click)="onPrefixChange(p)" (keydown)="onPrefixKeydown($event, p)" tabindex="0"
                [style.borderBottom]="!last ? '1px solid var(--Neutrals-Middle-Grey)' : 'none'" role="option"
                [attr.aria-selected]="selectedPrefix?.code === p.code">
                <div class="dropdown-item-content">
                    <img class="flag-icon" [src]="p.url" [alt]="p.code" loading="lazy" />
                    <div class="dropdown-meta">
                        <div class="country-name">{{ p.nameTranslated }}</div>
                        <div class="country-prefix">{{ p.prefix }}</div>
                    </div>
                </div>

                <img *ngIf="selectedPrefix?.code === p.code" class="check-icon" src="/assets/icons/solid_check.webp"
                    alt="" />
            </div>
        </div>
    </div>
</div>